import { createFileRoute } from "@tanstack/react-router";

import SettingsPage from "@/pages/settings/SettingsPage";

export const Route = createFileRoute("/_secure/settings/team")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SettingsPage route="/settings/team" />;
}
